
<template>
  <card>

    <vue-tabs active-tab-color="#9b59b6" 
           active-text-color="white">
      <v-tab  v-for="(item, index) in AdItems" class="card border-top-0" :title="item.name" :key="item.id">
        <div class="row p-3">
          <div class="col-11 d-flex flex-column">

            <div class="w-100 d-flex justify-content-between">
              <div>
                <label>Tür</label>
                <select v-model="item.type">
                  <option value="Kod">Kod</option>
                  <option value="Resim">Resim</option>
                </select> 
              </div>
              <div class="w-25 d-flex justify-content-end align-items-center" v-if="item.type=='Resim'">
                <input placeholder="Genişlik" disabled v-model="item.width" v-b-tooltip title="Genişlik" class="mr-2 form-control d-inline-block w-25">
                <span>X</span>
                <input placeholder="Yükseklik" disabled v-model="item.height" v-b-tooltip title="Yükseklik" class="form-control ml-2 d-inline-block w-25">
              </div>
            </div>
            <div v-if="item.type=='Kod'">
              <label>Kod</label>
              <div class="input-group mb-3" v0>
                <textarea v-model="item.content" class="form-control">

                </textarea>
              </div>
            </div>
            <div v-if="item.type=='Resim'">
              <img class="rounded m-2" style="width:300px;" :src="mediaURL() + item.image">
              <label for="" class="text-danger d-block">Önemli: Reklama tıklandığında kullanıcı aşağıdaki sayfaya yönlendirilecektir.</label>
              <div class="input-group mb-3">
                <div class="input-group-prepend">
                  <span class="input-group-text" id="basic-addon1">Link</span>
                </div>
                
                <input type="text" class="form-control" v-model="item.link" placeholder="Link " id="name" aria-describedby="basic-addon1">
              </div>
              <button  v-on:click="initiateUpload(index)" class="btn btn btn-xs btn-success btn-fill"><i class="fas fa-image fa-fw"></i></button>
            </div>


          </div>
          <div class="col-1 d-flex justify-content-end align-items-center">
            <div> 
              <a href="javascript:void(0)" class="btn btn-xs btn-primary btn-fill" v-on:click="save(item.id,index)" v-b-tooltip title="Kaydet"><i class="fas fa-save fa-fw"></i></a>

            </div>

            <img v-bind:src="newAdImage.cropped" class="img-fluid mt-4 border border-secondary p-2 d-none">
          </div>
        </div>
      </v-tab>
    </vue-tabs>

    <label for="newFile" v-if="newFileUploading.active" class="btn btn btn-xs btn-success btn-fill">
                <input type="file" class="d-none" ref="newFile" v-on:change="uploadFile()" name="newFile" id="newFile">
                Dosya Yükle
              </label>



    <b-modal id="croppieModal" hide-footer size="lg" title="Resim Seç">
      <input name="myFile" id="myImage" class="m-3" type="file" @change="bind()">
      <vue-croppie :enable-resize="false" :viewport="viewport" :boundary="boundary" ref=main :enableOrientation="true" @result="result">
      </vue-croppie>
      <b-btn class="mt-3" variant="danger btn-fill" @click="hideCroppieModal()">İptal</b-btn>
      <b-btn class="mt-3" id="submit-image" variant="success btn-fill float-right" @click="changeButtonText()">Kaydet</b-btn>
    </b-modal>
  </card>
</template>
<script>
  import Card from 'src/components/UIComponents/Cards/Card.vue'
  import { ModelSelect } from 'vue-search-select'

  export default {
    data: function () {
      return {
        newFileUploading: {
          active: false,
          index: -1
        },
        slider: {
          post_id: null,
          slider_group: 'Main',
          order_number: null,
          is_active: 1
        },
        viewport: {
          width: 480,
          height: 270,
          type: 'suare'
        },
        boundary: {
          width: 640,
          height: 360
        },
        selectedType: null,
        types: ['URL', 'Kategori', 'Alt Kategori', 'Yayın', 'Etiket'],
        options: [],
        AdItems: null,
        newAdImage: {
          cropped: null,
          index: null
        },
        total: 0,
        limit: localStorage.getItem('filterLimit'),
        page: 1,
        pageCount: null,
        navigation: true,
        type: 'all',
        viewCounts: []
      }
    },
    components: {
      Card,
      ModelSelect
    },

    methods: {
      initiateUpload: function (i) {
        this.newFileUploading = {
          active: true,
          index: i
        }
      },
      uploadFile: function () {
        let item = this.AdItems[this.newFileUploading.index]
        let slug = this.slugify(item.name)
        const file = this.$refs.newFile.files[0]
        let ext = file.name.split('.').pop()
        var reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = () => {
          this.$http.post('/api/images/upload-file/ad-' + slug + '-image-' + (new Date()).getTime(), {
            file: reader.result,
            ext
          }).then(
            response => {
              item.image = response.body.Data.Response.name
              this.newFileUploading = {
                active: false,
                index: -1
              }
            },
            e => {
              this.notifier('top', 'right', 'danger', 'Bir Hata Oluştu')
              this.toggleLoader()
            })
        }
      },
      remove: function (id) {
        this.toggleLoader()
        this.$http.delete('/api/slider/delete/' + id).then(
          response => {
            this.notifier('top', 'right', 'warning', 'Menu elemanı silindi')
            this.getAds()
            this.toggleLoader()
          },
          e => {
            this.notifier('top', 'right', 'danger', 'Bir Hata Oluştu')
            this.toggleLoader()
          })
      },
      uploadImage: function () {
        this.$http.post('/api/images/upload/ad-' + this.newAdImage.index + '-image', this.newAdImage).then(
          response => {
            this.AdItems[this.newAdImage.index].image = response.body.Data.Response.name
            this.hideCroppieModal()
            document.getElementById('submit-image').innerHTML = 'Kaydet'
            this.toggleLoader()
          },
          e => {
            this.notifier('top', 'right', 'danger', 'Bir Hata Oluştu')
            this.toggleLoader()
          })
      },
      update: function (id) {
        this.$http.post('/api/slider/edit/', this.AdItems).then(
          response => {
            this.notifier('top', 'right', 'success', 'Sıralama güncellendi')
          },
          e => {
            this.notifier('top', 'right', 'danger', 'Bir Hata Oluştu')
          })
      },
      save: function (id, i) {
        this.toggleLoader()
        if (this.AdItems[i].type === 'Resim') {
          this.AdItems[i].content = null
        } else {
          this.AdItems[i].image = null
          this.AdItems[i].link = null
        }
        this.$http.post('/api/ad-places/edit/' + id, this.AdItems[i]).then(
          response => {
            this.getAds()
            this.toggleLoader()
            this.notifier('top', 'right', 'success', 'Sıralama güncellendi')
          },
          e => {
            this.toggleLoader()
            this.notifier('top', 'right', 'danger', 'Bir Hata Oluştu')
          })
      },
      getAds: function () {
        this.toggleLoader()
        var url = '/api/ad-places/all'
        this.$http
          .get(url)
          .then(
            response => {
              this.AdItems = response.body
              if (this.AdItems.length > 0) {
                this.slider.order_number = this.AdItems[0].order_number + 1
                this.slider.post_id = 0
              } else {
                this.slider.order_number = 0
              }
              this.toggleLoader()
            },
            er => {
              this.notifier(
                'top',
                'right',
                'danger',
                'Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.'
              )
              this.toggleLoader()
            })
      },
      initiateCroppie: function (i) {
        this.newAdImage.index = i
        this.viewport.width = this.AdItems[i].width / 2
        this.viewport.height = this.AdItems[i].height / 2
        this.boundary.width = this.AdItems[i].width / 1.7
        this.boundary.height = this.AdItems[i].height / 1.7
        this.$refs.main.refresh()
      },
      toggleNavigation () {
        var button = event.target
        if (this.navigation) {
          button.innerHTML = '<i class="fas fa-caret-down"></i>'
          this.navigation = false
        } else {
          button.innerHTML = '<i class="fas fa-caret-up"></i>'
          this.navigation = true
        }
      },
      toggleNewPostPanel (event) {
        event.stopPropagation()
        if (document.getElementById('new-post').classList.contains('d-none')) {
          document.getElementById('new-post').classList.remove('d-none')
        } else {
          document.getElementById('new-post').classList.add('d-none')
        }
      },
      bind () {
        var oFReader = new FileReader()
        if (document.getElementById('myImage').files.length) {
          oFReader.readAsDataURL(document.getElementById('myImage').files[0])
          var refz = this.$refs
          oFReader.onload = function (oFREvent) {
            refz.main.bind({
              url: oFREvent.target.result
            })
          }
        }
      },
      changeButtonText: function () {
        document.getElementById('submit-image').innerHTML = "<i class='fas fa-circle-notch fa-spin'></i>"
        this.crop()
      },
      crop () {
        var dis = this
        this.toggleLoader()
        return new Promise(resolve => {
          let options = {
            format: 'jpeg',
            size: {
              width: this.AdItems[this.newAdImage.index].width,
              height: this.AdItems[this.newAdImage.index].height
            },
            quality: 1
          }
          dis.$refs.main.result(options, (output) => {
            this.newAdImage.cropped = output
            this.uploadImage()
            dis.$refs.main.refresh()
            resolve(output)
          })
        })
      },
      hideCroppieModal () {
        this.$root.$emit('bv::hide::modal', 'croppieModal')
      },
      result (output) {
        return output
      }
    },
    mounted: function () {
      this.$nextTick(function () {
        this.getAds()
      })
    }
  }
</script>
<style>
.nav .nav-item .nav-link:hover, .nav .nav-item .nav-link:focus{
  background-color: #007bff !important;
}
.nav-pills:focus{
  outline: none;
}
.nav-pills a{
  color:#000;
}

.nav .nav-item .nav-link:hover, .nav .nav-item .nav-link:focus{
  color:#fff;
}
.nav-item{
  margin-bottom: 5px;
}


.bg-gray{
  background-color: #bdc3c7 !important;
}
textarea.form-control{
  height: 100px;
  border-style: solid !important;
  border-width: 1px !important;
  border-color:rgb(170, 170, 170) !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/AdModules/Index.vue